import React from 'react'
import { useText } from '../../texts'

function Switch(props) {
  const t = useText()
  return (
    <div className="switch">
      <div
        onClick={() => props.handle(props.variants[0])}
        className={`switch__item ${
          props.value === props.variants[0] ? 'active' : ''
        }`}
      >
        {t(props.variants[0])}
      </div>

      <div
        onClick={() => props.handle(props.variants[1])}
        className={`switch__item ${
          props.value === props.variants[1] ? 'active' : ''
        }`}
      >
        {t(props.variants[1])}
      </div>
    </div>
  )
}

export default Switch
